import type { FC } from 'react';

import { Button, FormRow, Link, Modal } from '../../components';

export type ResetModalData = {
    reset_email_url: string;
    reset_email_name: string;
} | null;
export interface ResetModal {
    heading: string;
    subheading: string;
    data?: ResetModalData;
}
export interface LinkSentModalProps {
    onClose: () => void;
    resetModal: ResetModal;
}

const LinkSentModal: FC<LinkSentModalProps> = ({ onClose, resetModal }) => (
    <Modal title={resetModal.heading} onCloseHandler={onClose}>
        <FormRow>
            It should reach your inbox instantly. If it&apos;s not there in 5 minutes,{' '}
            <Link href="mailto:support@lokalise.com">contact us</Link>.
        </FormRow>
        {!!resetModal.data && (
            <Button
                onClick={() => {
                    if (!resetModal.data) {
                        return;
                    }

                    window.location.assign(resetModal.data.reset_email_url);
                }}
            >
                Take me to {resetModal.data.reset_email_name}
            </Button>
        )}
    </Modal>
);

export default LinkSentModal;
